(function($) {
    $(document).ready(function() {
        deckHelp.init();
    }); // document.ready

    var deckHelp = {

        body: {},

        init: function() {
            deckHelp.body = $('body');
            deckHelp.initModalListeners();
            deckHelp.initInfoTagListeners();
            deckHelp.escKey();
        },

        // --------------------------------------------
        // ---------------- HELP MODAL ----------------
        // --------------------------------------------
        // init the listeners to open the modal
        initModalListeners: function() {
            // listen for modal open clicks
            $('.open-help-modal').on('click', function(e){
                e.preventDefault();
                deckHelp.openHelp();
            });

            // close modal if they click on background
            $('.help-modal').on('click', function(e){
                if (e.target == this) {
                    deckHelp.closeHelp();
                }
            });

            // close modal if they click on close button
            $('.help-modal .close').on('click', function(e){
                e.preventDefault();
                deckHelp.closeHelp();
            });

            // send GA click event
            $('[data-ga-type="static"]').on('click', function(e){
                e.preventDefault();
                var $this = $(this);
                ga('send', 'event', 'Deck Builder', 'click', 'Contact Us | ' + $this.data('ga-title'));
            });

        },

        // open the modal
        openHelp: function() {
            deckHelp.body.addClass('help-modal-open');
        },

        // close the modal
        closeHelp: function() {
            deckHelp.body.removeClass('help-modal-open');
        },


        // --------------------------------------------
        // ------------ INFO TOGGLE MODAL -------------
        // --------------------------------------------
        initInfoTagListeners: function() {

            // open up the info toggles
            $('.info-toggle').on('click', function(e){

                // remove any previos info toggles
                $('.info-toggle-modal').remove();

                // build the modal
                var $this = $(this),
                    $legend = $this.closest('.legend'),
                    offset = deckHelp.getScrollPosition($legend),
                    modalHtml = '<div class="info-toggle-modal">' +
                            '<div class="inner" style="top:' + offset.top + 'px ; left: ' + offset.left + 'px">' +
                                $this.data('tip') +
                            '</div>' +
                        '</div>';

                // append modal to DOM
                $('body').append(modalHtml);
            });

            // close modal if they click on close button
            $('body').on('click', '.info-toggle-modal', function(e){
                e.preventDefault();
                deckHelp.closeInfoToggle();
            });
        },

        // close the info toggle modal
        closeInfoToggle: function() {
            $('.info-toggle-modal').remove();
        },


        // --------------------------------------------
        // ----------------- HELPERS ------------------
        // --------------------------------------------
        // add excape key listener to close
        escKey: function() {
            // global excape key
            $(document).keyup(function(e) {
                if (e.keyCode == 27) {
                    // close modal
                    deckHelp.closeHelp();
                    deckHelp.closeInfoToggle();
                }
            });
        },

        // get the coordinate of an element relative to window scroll
        getScrollPosition: function($el) {
            return {
                top: $el.offset().top - $(window).scrollTop(),
                left: $el.offset().left
            }
        }
    };
})(jQuery);
